export const coinRankingReferenceCurrencies = {
	USD: 'yhjMzLPhuIDl',
	EUR: '5k-_VTxqtCEI',
	BTC: 'Qwsogvtv82FCd',
	ETH: 'razxDUgYGNAdQ',
};
